import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, NgZone, ChangeDetectorRef, AfterViewChecked, HostListener, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from "@angular/router";
import { ApiService } from '../api.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { slideInAnimation } from '../animations/route-animation';
declare var $: any;
import Swal from 'sweetalert2';
/* import { AngularFireMessaging } from '@angular/fire/compat/messaging'; */
import { provideMessaging, getMessaging, Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { MatSnackBar } from '@angular/material/snack-bar';
import { allModules, viewList, getDeviceId } from '../shared/constants';
import { environment } from '../../environments/environment';
import { MessagingService } from '../messaging.service';
import { Howl, Howler } from 'howler';
import { Timestamp, getCountFromServer, Firestore, collection, collectionData, query, where, collectionChanges, DocumentChange, orderBy, writeBatch, doc, getDocs, deleteDoc, onSnapshot, limit, startAfter, QuerySnapshot, DocumentData } from '@angular/fire/firestore';

@Component({
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrl: './navbar.component.scss',
	animations: [slideInAnimation]
})
export class NavbarComponent implements OnInit, AfterViewChecked {
	homeUrl = this.apiService.getHomeURL();
	handovers: any[] = [];
	handoverLoader = false;
	doneLoader: any = null;
	userAccess: any = null;
	user: any = null;
	loader1 = false;
	viewList = viewList;
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
				[{ 'list': 'ordered' }, { 'list': 'bullet' }],
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				[{ 'color': [] }, { 'background': [] }],
				[{ 'font': [] }],
				[{ 'align': [] }]
			]
		}
	};
	showInfo = false;
	playAlertRing = new Howl({
		src: ['../../assets/files/mixkit-vintage-telephone-ringtone-1356.wav']
	});
	doctorList: any[] = [];

	constructor(private firestore: Firestore, private messagingService: MessagingService, private messaging: Messaging,/* private angularFireMessaging: AngularFireMessaging, */ private _snackBar: MatSnackBar, private changeRef: ChangeDetectorRef, private observer: BreakpointObserver, private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, private zone: NgZone) { }

	ngOnInit(): void {
		this.loader1 = true;
		this.getUser();
		this.getAllDoctors();
	}

	ngAfterViewChecked(): void {
		this.changeRef.detectChanges();
	}

	getUser() {
		this.apiService.getLoggedInUser().subscribe({
			next: (data: any) => {
				this.userAccess = data.data.access;
				if (!this.userAccess) {
					this.userAccess = {};
				}
				for (let i = 0; i < allModules.length; i++) {
					if (!this.userAccess[allModules[i].key]) {
						this.userAccess[allModules[i].key] = "NoAccess";
					}
				}
				/* let excludeKeys = [
					"User_Master",
				];
				for (let i = 0; i < excludeKeys.length; i++) {
					this.userAccess[excludeKeys[i]] = "Full";
				} */
				data.data.user.company = data.data.company;
				data.data.user.email_signature = data.data.email_signature;
				data.data.user.company_name = data.data.company_details?.com_name;
				data.data.user.usertype = data.data.type || "SC";
				this.user = data.data.user;
				try {
					if (data.data.dashboard_view) {
						for (let i = 0; i < this.viewList.length; i++) {
							for (let j = 0; j < data.data.dashboard_view.length; j++) {
								if (this.viewList[i].key === data.data.dashboard_view[j].key) {
									this.viewList[i] = data.data.dashboard_view[j];
								}
							}
						}
					}
				} catch (error) { }
				if (localStorage.getItem("usertype") != this.user.usertype) {
					this.logoutUser();
				}
				this.apiService.setUserData(this.user);
				this.loader1 = false;
				/* this.angularFireMessaging.requestToken.subscribe({
					next: (token) => {
						if (token) {
							this.apiService.saveDeviceToken(token, this.user.id).subscribe({ next: (data: any) => { }, error: (error) => { } });
						}
					}, error: (err) => {
					}
				}); */
				this.messagingService.requestPermission().then((permission) => {
					if (permission === 'granted') {
						getToken(this.messaging, { vapidKey: environment.firebaseConfig.vapiKey }).then((token) => {
							if (token) {
								this.apiService.saveDeviceToken(token, this.user.id, getDeviceId()).subscribe({ next: (data: any) => { }, error: (error) => { } });
							} else {
								console.log('No registration token available. Request permission to generate one.');
							}
						}).catch((err) => {
							console.error('An error occurred while retrieving token. ', err);
						});
					} else {
						console.log('Notification permission not granted.');
					}
				});
				this.messagingService.login().then(userCredential => {
					this.listenForMsgAndMail();
					this.listenForCall();
				}).catch(error => { });
			}, error: (error) => {
				this.userAccess = {};
				for (let i = 0; i < allModules.length; i++) {
					this.userAccess[allModules[i].key] = "NoAccess";
				}
				this.user = null;
				this.apiService.setUserData(this.user);
				this.loader1 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	listenForMsgAndMail() {
		onMessage(this.messaging, (message) => {
			console.log(message);
			const mail_title = "New Email Arrived";
			const audio_call_title = "Audio Call";
			const video_call_title = "Video Call";
			const message_title = "New Message";
			const call_disconnect_title = "Call Disconnected";
			const id = message.data?.enc_id;
			let noti_title = message.data?.title;
			let title = "";
			let popupDuration: any = 3 * 1000;
			let showNotification = true;
			if (noti_title == mail_title) {
				title = "View mail";
				this.apiService.sendCountChangeEvent();
			} else if (noti_title == audio_call_title || noti_title == video_call_title) {
				showNotification = false;
				/* title = "Join call";
				popupDuration = 10 * 1000;
				if (this.userAccess?.Chat != 'Full') {
					showNotification = false;
				}
				const sent_at = Number(message.data?.sent_at);
				const EXPIRY_MINS = 5;
				const EXPIRY_MS = EXPIRY_MINS * 60 * 1000;
				if (Date.now() - sent_at > EXPIRY_MS) {
					showNotification = false;
				} */
			} else if (noti_title == message_title) {
				title = "View message";
				if (this.userAccess?.Chat != 'Full') {
					showNotification = false;
				}
				const sent_at = Number(message.data?.sent_at);
				const EXPIRY_MINS = 5;
				const EXPIRY_MS = EXPIRY_MINS * 60 * 1000;
				if (Date.now() - sent_at > EXPIRY_MS) {
					showNotification = false;
				}
			} else if (noti_title == call_disconnect_title) {
				showNotification = false;
				/* this.apiService.sendCallDisconnectedEvent(id); */
			}
			if (showNotification) {
				if (noti_title == audio_call_title || noti_title == video_call_title) {
					if (this.playAlertRing) {
						try {
							this.playAlertRing.stop();
						} catch (error) { }
					}
					this.playAlertRing.play();
				}
				this._snackBar.open(message.data?.body!, title, {
					horizontalPosition: "end",
					verticalPosition: "bottom",
					duration: popupDuration,
				}).onAction().subscribe(() => {
					if (id) {
						if (noti_title == mail_title) {
							const url = this.router.serializeUrl(
								this.router.createUrlTree(["/app/mailbox/folder/unlinked", id])
							);
							window.open(url, '_blank');
						} else if (noti_title == audio_call_title || noti_title == video_call_title || noti_title == message_title) {
							let chatAction = 'no';
							if (noti_title == audio_call_title) {
								chatAction = "audio";
								if (this.playAlertRing) {
									try {
										this.playAlertRing.stop();
									} catch (error) { }
								}
							} else if (noti_title == video_call_title) {
								chatAction = "video";
								if (this.playAlertRing) {
									try {
										this.playAlertRing.stop();
									} catch (error) { }
								}
							} else if (noti_title == message_title) {
								chatAction = "chat";
							}
							const url = this.router.serializeUrl(
								this.router.createUrlTree(["/app/appt-details", chatAction, id, "empty"])
							);
							window.open(url, '_blank');
						}
					} else {
						console.error("Notification click error. No case id");
					}
				});
			}
		});
	}

	listenForCall() {
		const colRef = collection(this.firestore, 'call');
		const callQuery = query(
			colRef,
			where('from', '==', "candidate")
		);
		let isInitialLoad = true;
		onSnapshot(callQuery, (snapshot) => {
			if (isInitialLoad) {
				isInitialLoad = false;
				return;
			}
			snapshot.docChanges().forEach((change) => {
				if (change.type === 'added') {
					const fs_document = {
						id: change.doc.id,
						...change.doc.data()
					};
					if (
						(fs_document["type"] == "video" || fs_document["type"] == "audio") &&
						fs_document["action"] == "connect"
					) {
						const id = btoa(fs_document["channel"]);
						let showNotification = true;
						if (this.userAccess?.Chat != 'Full') {
							showNotification = false;
						}
						if (fs_document["timestamp"]) {
							try {
								let date: any;
								if (fs_document["timestamp"].toDate) {
									date = fs_document["timestamp"].toDate();
								} else {
									date = fs_document["timestamp"];
								}
								const EXPIRY_MINS = 0.5;
								const EXPIRY_MS = EXPIRY_MINS * 60 * 1000;
								const isOlder = (Date.now() - date.getTime()) > EXPIRY_MS;
								if (isOlder) {
									showNotification = false;
								}
							} catch (error) { }
						}
						if (showNotification) {
							fs_document["case_enc_id"] = id;
							if (fs_document["case_enc_id"]) {
								this.apiService.getUpdateCaseDetails({ id: fs_document["case_enc_id"] }).subscribe({
									next: (data: any) => {
										fs_document["case_id"] = data["case_id"];
										this.showNotification(fs_document);
									}, error: (error) => {
										this.showNotification(fs_document);
									}
								});
							} else {
								this.showNotification(fs_document);
							}
						}
					}
				}
			});
		});
	}

	showNotification(fs_document: any) {
		let body = "";
		if (fs_document["type"] == "audio") {
			body = "Audio call";
		} else if (fs_document["type"] == "video") {
			body = "Video call";
		}
		if (fs_document["case_id"]) {
			body += " from " + fs_document["case_id"];
		}
		if (this.playAlertRing) {
			try {
				this.playAlertRing.stop();
			} catch (error) { }
		}
		let popupDuration: any = 3 * 1000;
		popupDuration = 10 * 1000;
		this.playAlertRing.play();
		this._snackBar.open(body, "Join call", {
			horizontalPosition: "end",
			verticalPosition: "bottom",
			duration: popupDuration,
		}).onAction().subscribe(() => {
			if (fs_document["case_enc_id"]) {
				let chatAction = 'no';
				if (fs_document["type"] == "audio") {
					chatAction = "audio";
					if (this.playAlertRing) {
						try {
							this.playAlertRing.stop();
						} catch (error) { }
					}
				} else if (fs_document["type"] == "video") {
					chatAction = "video";
					if (this.playAlertRing) {
						try {
							this.playAlertRing.stop();
						} catch (error) { }
					}
				}
				const url = this.router.serializeUrl(
					this.router.createUrlTree(["/app/appt-details", chatAction, fs_document["case_enc_id"], "empty"])
				);
				window.open(url, '_blank');
			} else {
				console.error("Notification click error. No case id");
			}
		});
	}

	existing_signature: any;
	openUserModal() {
		this.existing_signature = this.user.email_signature;
		$("#userModalNavbar").modal("show");
	}

	showLoader = false;
	saveUserSignature() {
		const data: any = {
			/* type: this.user.usertype, */
			first_name: this.user.first_name,
			last_name: this.user.last_name,
			username: this.user.username,
			email: this.user.email,
			/* sign: this.user.sign, */
			access: this.userAccess,
			email_signature: this.user.email_signature,
			id: this.user.enc_id
		};
		this.showLoader = true;
		this.apiService.createUpdateUser(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.closeSignModal();
				this.toastr.success("Updated successfully", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	closeSignModal() {
		$("#userModalNavbar").modal("hide");
		if (this.existing_signature != this.user.email_signature) {
			this.getUser();
		}
	}

	prepareRoute(outlet: RouterOutlet) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
	}

	openHandoverModal() {
		$("#allHandoverModal").modal("show");
		this.getHandover();
	}

	getHandover() {
		this.handovers = [];
		this.handoverLoader = true;
		this.apiService.getHandover({}).subscribe({
			next: (data: any) => {
				this.handovers = data;
				this.handoverLoader = false;
			}, error: (error) => {
				this.handoverLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		})
	}

	doneHandover(handover: any) {
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want change status to "Done"?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.doneLoader = handover.id;
				this.apiService.doneHandover({ id: handover.enc_id }).subscribe({
					next: (data: any) => {
						this.getHandover();
						this.doneLoader = null;
						this.toastr.success('Saved successfully', 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}, error: (error) => {
						this.doneLoader = null;
						this.toastr.error('Something went wrong', 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				})
			}
		})
	}

	openDashboardSettingModal() {
		this.check_uncheck();
		$("#dashboardSettingsModal").modal("show");
	}

	selectAll = false;
	check_uncheck_all() {
		for (let i = 0; i < this.viewList.length; i++) {
			this.viewList[i].selected = this.selectAll;
		}
	}

	check_uncheck() {
		let allChecked = true;
		for (let i = 0; i < this.viewList.length; i++) {
			if (!this.viewList[i].selected) {
				allChecked = false;
			}
		}
		this.selectAll = allChecked;
	}

	saveDashSettingLoader = false;
	saveDashboardSetting() {
		this.saveDashSettingLoader = true;
		this.apiService.updateUser({ dashboard_view: this.viewList }).subscribe({
			next: (data: any) => {
				this.saveDashSettingLoader = false;
				/* this.getUser(); */
				this.toastr.success('Saved successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				$("#dashboardSettingsModal").modal("hide");
			}, error: (error) => {
				this.saveDashSettingLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		})
	}

	isViewSaved(view: string) {
		return this.viewList.find((v) => v.key == view && v.selected);
	}

	getSavedViewCount() {
		return this.viewList.filter((v) => v.selected).length;
	}

	logoutUser() {
		this.apiService.logout().subscribe({
			next: () => {
				this.apiService.navigateToLogin(false);
			}, error: () => {
				this.apiService.navigateToLogin(false);
			}
		});
	}

	getEncodedId(caseId: string) {
		return btoa(caseId);
	}

	scrollToTop() {
		let selector = "#page-content-container-common";
		try {
			$('html, body').animate({
				scrollTop: $(selector).offset().top - 70 + 'px'
			}, 'fast');
		} catch (error) { }
	}

	showScrollBtn = false;
	@HostListener('window:scroll', ['$event'])
	onScroll(e: any) {
		try {
			if ($('#main-menu-header').offset().top) {
				this.showScrollBtn = true;
			} else {
				this.showScrollBtn = false;
			}
		} catch (error) { }
	}

	isActive(base: string): boolean {
		return this.router.url.startsWith(`/${base}`);
	}

	getAllDoctors() {
		this.apiService.getDoctorList({}).subscribe({
			next: (data: any) => {
				this.doctorList = data.data;
				this.apiService.setDoctorData(this.doctorList);
			}, error: (error) => {
				this.doctorList = [];
			},
		});
	}

	filterDoctors(hospital_id: any = null) {
		return this.doctorList.filter((doc: any) => {
			if (hospital_id) {
				return doc.hospitals.find((h: any) => h.id == hospital_id) ? true : false;
			} else {
				return true;
			}
		})
	}

	pageLoading2 = false;
	saved_mfa_enabled = false;
	mfa_enabled = false;
	showMFAForm1 = false;
	showMFAForm2 = false;
	hide_mfa = false;
	qr_code: any;
	mfaForm1: FormGroup = this.formBuilder.group({
		password: [null, [Validators.required]]
	});
	get f1() { return this.mfaForm1.controls; }
	mfaForm2: FormGroup = this.formBuilder.group({
		user_code: [null, [Validators.required, Validators.pattern('^[0-9]{6}$')]],
		access_token: [null, [Validators.required]]
	});
	get f2() { return this.mfaForm2.controls; }

	openMFAModal() {
		this.showMFAForm1 = false;
		this.showMFAForm2 = false;
		this.getMFAStatus();
		$("#mfaModal").modal("show");
	}

	getMFAStatus() {
		this.pageLoading2 = true;
		const payload = {
			username: this.user.email
		}
		this.apiService.isMFAActivated(payload).subscribe({
			next: (data: any) => {
				this.pageLoading2 = false;
				this.mfa_enabled = data.mfa_enabled;
				this.saved_mfa_enabled = data.mfa_enabled;
			}, error: (error) => {
				this.pageLoading2 = false;
				if (error.status == 404) {
					this.hide_mfa = true;
				}
			}
		});
	}

	changeMFAStatus() {
		if (this.mfa_enabled) {
			if (!this.saved_mfa_enabled) {
				this.showMFAForm1 = true;
			}
		} else {
			this.showMFAForm1 = false;
			if (this.saved_mfa_enabled) {
				this.pageLoading2 = true;
				const payload = {
					username: this.user.email
				}
				this.apiService.disableMFA(payload).subscribe({
					next: (data: any) => {
						this.pageLoading2 = false;
						this.toastr.success("MFA disabled.", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.getMFAStatus();
					}, error: (error) => {
						this.pageLoading2 = false;
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	submitMFAPassword() {
		if (this.f1["password"].hasError('wrong_password')) {
			try {
				delete this.f1["password"].errors?.wrong_password;
				this.f1["password"].updateValueAndValidity();
			} catch (error) { }
		}
		if (this.mfaForm1.invalid) {
			this.toastr.warning("Please check required parameters.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const payload = {
			email: this.user.email,
			password: this.f1.password.value
		}
		this.pageLoading2 = true;
		this.apiService.activateMFA(payload).subscribe({
			next: (data: any) => {
				this.f2.access_token.setValue(data["access_token"]);
				this.qr_code = data["qr_code"];
				this.pageLoading2 = false;
				this.showMFAForm1 = false;
				this.showMFAForm2 = true;
			}, error: (error) => {
				this.pageLoading2 = false;
				this.f1.password.setErrors({ wrong_password: true });
			}
		});
	}

	verifyMFA() {
		if (this.f2["user_code"].hasError('wrong_password')) {
			try {
				delete this.f2["user_code"].errors?.wrong_password;
				this.f2["user_code"].updateValueAndValidity();
			} catch (error) { }
		}
		if (this.mfaForm2.invalid) {
			this.toastr.warning("Please check required parameters.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const payload = {
			access_token: this.f2.access_token.value,
			user_code: this.f2.user_code.value
		}
		this.pageLoading2 = true;
		this.apiService.verifyMFA(payload).subscribe({
			next: (data: any) => {
				this.pageLoading2 = false;
				this.showMFAForm1 = false;
				this.showMFAForm2 = false;
				this.toastr.success("MFA activated successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getMFAStatus();
			}, error: (error) => {
				this.pageLoading2 = false;
				this.f2.user_code.setErrors({ wrong_password: true });
			}
		});
	}
}
